import { TypedUseSelectorHook, useSelector as useSelectorRedux } from 'react-redux'

import { State } from '../store'

export const useSelector: TypedUseSelectorHook<State> = useSelectorRedux
